import { useEffect, useRef } from 'react';

/**
 * Moves focus to the returned ref's element when `wanted` becomes true, then says it is done.
 * Used so focus lands somewhere sensible after the screen changes under the user.
 */
export function useFocusRequest<T extends HTMLElement>(wanted: boolean, done: () => void) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!wanted || !ref.current) return;
    ref.current.focus();
    done();
  }, [wanted, done]);
  return ref;
}
